import HomeHero from "../components/home/hero";

function Home() {
    return(<div><HomeHero/></div>)
}

export default Home;